import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild
} from '@angular/core';
import { FormElementBase } from '../form-element-base';

@Component({
  selector: 'radio-switch',
  templateUrl: './radio-switch.component.html',
  styleUrls: ['./radio-switch.component.css']
})
export class RadioSwitchComponent extends FormElementBase implements OnInit {
  @ViewChild('radioSwitch', { static: true }) radioSwitch: ElementRef;

  constructor() {
    super();
  }

  ngOnChanges(obj?: any) {
    this.errorMessage = '';
    for (this.i = 0; this.i < this.errors.length; this.i++) {
      if (this.errors[this.i]['name'] == this.settings.name) {
        if (this.errors[this.i]['isValid'] == false) {
          this.errorMessage = this.errors[this.i]['error'];
        } else {
          this.errorMessage = '';
        }
      }
    }
    if (obj.hasOwnProperty('value')) {
      this.radioSwitch.nativeElement.dispatchEvent(
        new Event('click', { bubbles: true })
      );
      if (this.form) {
        this.form.controls[this.settings['formControlName']].setValue(
          this.settings.value
        );
        this.valueChange();
      }
    }
  }
}
